<template>
<div>
    <Header />
    <div id="screen-roles-manager" class="container mt-lg-5 mb-5">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-5 mt-4 mt-md-5 mt-lg-0" >
                <div class="table-roles-user card">
                    <div class="table-roles-user title">
                        <div class="row">
                            <div class="col-6">
                                <h6>ACCOUNT CUSTOMER</h6>
                            </div>
                            <div class="col-6 d-flex justify-content-end">
                                <button v-on:click="hidenDivError()"
                                        v-if="checkPermission(screenCode, 'CREATE')"
                                        type="button" class="btn btn-sm btn-primary sku-btn"
                                        data-toggle="modal" data-target="#addAccountCustomer">
                                    <i class="fa fa-plus mr-1"></i>Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table-roles-user pt-0" style="border-left: none; display: flex;">
                        <input class="form-control" type="text" placeholder="Search By Code" v-model="txtSearch" v-on:keyup.enter="searchAccountCustomer()" />
                        <button type="button" class="btn sku-btn ml-2" v-on:click="searchAccountCustomer()">Search</button>
                    </div>
                    <div class="list-grid content-table col-12" v-if="loadingAccount">
                        <div class="text-center">
                            <div class="spinner-border text-dark" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="list-grid content-table col-12">
                        <table class="table table-hover table-md">
                            <thead>
                                <tr>
                                    <th>CODE</th>
                                    <th>NAME</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in accCus" v-bind:key="item.id">
                                    <td v-on:click="searchAccountUserByCode(item.code)">{{item.code}}</td>
                                    <td v-on:click="searchAccountUserByCode(item.code)">{{item.name}}</td>
                                    <!-- <td class="idRoleMoveToModel">{{ item.id}}</td> -->
                                    <td class="text-right">
                                        <div class="dropdown">
                                            <button class="dropbtn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Hành động
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a
                                                    class="dropdown-item"
                                                    v-on:click="getTextOnclick3(item.code)"
                                                    data-toggle="modal"
                                                    data-target="#addAccountUserCustomer"
                                                    href="javascript:void(0)">
                                                    Thêm tài khoản</a>
                                                <a
                                                    class="dropdown-item"
                                                    v-on:click="getTextOnclick2(item.id ,item.code)"
                                                    data-toggle="modal"
                                                    data-target="#deleteAccountCus"
                                                    href="javascript:void(0)">
                                                    Xóa tài khoản</a>
                                                <a
                                                    class="dropdown-item"
                                                    v-on:click="clickEditAccountUser(item.code,item.name,item.deptCode,item.id)"
                                                    data-toggle="modal"
                                                    data-target="#editAccountCustomer"
                                                    href="javascript:void(0)">
                                                    Chỉnh sửa</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row mt-4 pagination" v-if="totalPagesAccountCus>1">
                            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
                                <span v-if="perPageAccountCus*pageAccountCus<totalDataAccountCus">{{perPageAccountCus*(pageAccountCus-1)+1}}-{{perPageAccountCus*pageAccountCus}} of {{totalDataAccountCus}}</span>
                                <span v-else>{{perPageAccountCus*(pageAccountCus-1)+1}}-{{totalDataAccountCus}} of {{totalDataAccountCus}}</span>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
                                <b-pagination :total-rows="totalDataAccountCus" v-model="pageAccountCus" :per-page="perPageAccountCus" style="float: right"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-7 mt-4 mt-md-5 mt-lg-0" >
                <div class="table-roles-user card">
                    <div class="table-roles-user title">
                        <h6>TÀI KHOẢN</h6>
                    </div>
                    <div class="table-roles-user pt-0" style="border-left: none; display: flex;">
                        <input class="form-control" type="text" placeholder="Search By User" v-model="txtSearchUser" v-on:keyup.enter="searchAccountUserCustomerByUser()" />
                        <button v-on:click="searchAccountUserCustomerByUser()" type="button" class="btn sku-btn ml-2">Search</button>
                    </div>
                    <div class="list-grid content-table col-12" v-if="loadingUser">
                        <div class="text-center">
                            <div class="spinner-border text-dark" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="list-grid content-table col-12">
                        <table class="table table-hover table-md">
                            <thead>
                                <tr>
                                    <th>CODE</th>
                                    <th>TYPE</th>
                                    <th>USER</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in accUserCus" v-bind:key="item.id">
                                    <td>{{ item.code}}</td>
                                    <td>{{ item.type}}</td>
                                    <td>{{ item.user}}</td>
                                    <td>
                                        <button v-on:click="getTextOnclick(item.id)" data-toggle="modal" data-target="#deleteAccountUserCus" class style="font-size: 0.75rem; height: 30px;border: 1px solid #e7eaec; padding: 0 5px;">
                                            Xóa
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row mt-4 pagination" v-if="totalPages>1 && isDisplaypagingSearchCode">
                            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
                                    <span v-if="perPage*pageSearchByCode<totalData">{{perPage*(pageSearchByCode-1)+1}}-{{perPage*pageSearchByCode}} of {{totalData}}</span>
                                    <span v-else>{{perPage*(pageSearchByCode-1)+1}}-{{totalData}} of {{totalData}}</span>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
                                <!-- <b-pagination :total-rows="totalData" v-model="page" :per-page="perPage"  /> -->
                                <b-pagination :total-rows="totalData" v-model="pageSearchByCode" :per-page="perPage" style="float: right" />
                            </div>
                        </div>
                        <div class="row mt-4 pagination" v-if="totalPages>1 && isDisplaypagingAccount">
                            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
                                <span v-if="perPage*page<totalData">{{perPage*(page-1)+1}}-{{perPage*page}} of {{totalData}}</span>
                                <span v-else>{{perPage*(page-1)+1}}-{{totalData}} of {{totalData}}</span>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
                                <b-pagination :total-rows="totalData" v-model="page" :per-page="perPage" style="float: right" />
                                <!-- <b-pagination :total-rows="totalData" v-model="pageSearchByCode" :per-page="perPage"  /> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Add Account USER Customer Modal start -->
    <div class="modal fade" id="addAccountUserCustomer" tabindex="-1" role="dialog" aria-labelledby="addAccountUserCustomerLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addAccountUserCustomerLabel">Add User</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Code</label>
                            </div>
                            <div class="col-9">
                                <input v-model="userAccountCustomerForm.code" type="text" class="form-control" readonly />
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">User</label>
                            </div>
                            <div class="col-9">
                                <v-select :options="dataUser" label="account"
                                          v-model="userAccountCustomerForm.user"
                                          @search="searchEmployee($event)" id="selectUserInModel"
                                          :reduce="obj => obj.account"
                                />
                                <div class="error3 errortemp" style="display:none">
                                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Không được để trống.</div>
                                </div>
                        </div>
                      <div class="row mb-2">
                        <div class="col-3">
                          <label class="required">Type</label>
                        </div>
                        <div class="col-9">
                          <v-select
                            :options="['admin', 'user']"
                            v-model="userAccountCustomerForm.type"
                          ></v-select>
                          <div class="error3 errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Can not be empty.</div>
                        </div>
                      </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button v-on:click="hidenDivError()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button v-on:click="createAccountUserCustomer()" class="btn sku-btn" id="btn-save-acc-user-customer">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Add Account USER Customer end -->

    <!-- modal delete AccountUser  start -->
    <div class="modal fade" id="deleteAccountCus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deletedeleteAccountCusLabel">Delete</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">Are you sure you want to delete this item?</div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button v-on:click="deleteAccountCustomer()" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
    <!-- modal delete AccountUser  end -->

    <!-- Add AccountCustomer Modal start -->
    <div class="modal fade" id="addAccountCustomer" tabindex="-1" role="dialog" aria-labelledby="addAccountCustomerLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addAccountCustomerLabel">Add Account Customer</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Code</label>
                            </div>
                            <div class="col-9">
                                <input v-model="accCusVO.code" type="text" class="form-control" />
                                <div class="error errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Can not be empty.</div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Name</label>
                            </div>
                            <div class="col-9">
                                <input v-model="accCusVO.name" class="form-control input-name" />
                                <div class="error errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Can not be empty.</div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Department</label>
                            </div>
                            <div class="col-9">
                                <v-select label="departmentName" :options="depts" placeholder="--Select--" @search="fetchDepartment($event)" v-model="department" />
                                <div class="error errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> You need select.</div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button v-on:click ="clearText()" type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                    <button v-on:click="createAccountCus()" class="btn sku-btn" id="btn-save-acc-customer">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Add AccountCustomer end -->

    <!-- Edit AccountCustomer Modal start -->
    <div class="modal fade" id="editAccountCustomer" tabindex="-1" role="dialog" aria-labelledby="editAccountCustomerLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editAccountCustomerLabel">Edit Account User</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Code</label>
                            </div>
                            <div class="col-9">
                                <input v-model="accCusVO.code" type="text" class="form-control" readonly />
                                <div class="error2 errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Code not be empty.</div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Name</label>

                            </div>
                            <div class="col-9">
                                <input v-model="accCusVO.name" class="form-control input-name" />
                                <div class="error2 errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Name not be empty.</div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label class="required">Department</label>
                            </div>
                            <div class="col-9">
                                <v-select label="departmentName" :options="depts" :placeholder="accCusVO.deptCode" v-model="department" id="txtDept-editAccount" />
                                <div class="error2 errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> You need select Departmnet.</div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button v-on:click ="clearText()" type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                    <button v-on:click="editAccountCus()" class="btn sku-btn" id="btn-edit-acc-customer">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Edit AccountCustomer end -->

    <!-- modal delete AccountCus  start -->
    <div class="modal fade" id="deleteAccountUserCus" tabindex="-2" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deletedeleteAccountUserCusLabel">Delete</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">Are you sure you want to delete this item?</div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button v-on:click="deleteAccountUserCustomer()" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
    <!-- modal delete AccountCus  end -->

    <Footer />
</div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import Dropdown from "@/components/common/Dropdown.vue";

import departmentCommon from "../../common/department";
import employeeCommon from "../../common/employee";
import axios from "axios";
import helper from "../../common/helper";
import * as CONFIG from "../../config/index";
import jQuery from 'jquery';
import {
    BPagination
} from "bootstrap-vue";

export default {
    name: "AccountManager",
    components: {
        Header,
        Footer,
        "b-pagination": BPagination
    },

    data() {
        return {
            screenCode: CONFIG.SCREEN_CODE.ACCOUNT_MANAGER,
            // txtSearch: "",
            txtSearchUser: "",
            txtSearch: "",
            accUserCus: [],
            accCus: [],
            depts: [],
            accUserCusVO: {
                code: "",
                user: "",
            },
            accCusVO: {
                id: "",
                code: "",
                name: "",
                deptCode: "",
            },
            userAccountCustomerForm: {
              user: "",
              code: "",
              type: "",
            },
            dataUser: [],
            department: "",

            //paging AccountCustomer -start
            page: 1,
            perPage: 10,
            totalPages: 0,
            totalData: 0,
            // paging AccountCustomer-end

            //paging AccountCustomer -start
            pageAccountCus: 1,
            perPageAccountCus: 10,
            totalPagesAccountCus: 0,
            totalDataAccountCus: 0,
            // paging AccountCustomer-end
            txtCodeTodeleteAccountUser: "",
            pageSearchByCode: 1,

            tempCode: "",
            isDisplayPagingSearchCode: true,
            isDisplayPagingAccount: false,
            codeOld: "",
            codeAccountCustomer: "",
            loadingAccount: false,
            loadingUser: false,


        }

    },
    mounted() {
        this.getAccountUserCustomer();
        this.getAccountCustomer();
        this.getEmployee();
        this.getDepartment();
    },
    methods: {
        checkPermission: helper.checkPermission,
        test: function () {
            this.accCusVO.deptCode = this.department.departmentCode;
        },
        getAccountUserCustomer: function () {
            this.loadingUser = true;
            this.isDisplaypagingSearchCode = false;
            this.isDisplaypagingAccount = true;
            if (this.textSearch == null) {
                this.textSearch = "";
            }
            this.axios
                .get(`${CONFIG.API_URL}/account-user-customer/search?name=` + this.txtSearchUser + `&pageNo=` + this.page + `&pageSize=` + this.perPage)
                .then(restAccUserCus => {
                    this.accUserCus = restAccUserCus.data.data.items;
                    this.totalPages = Math.ceil(restAccUserCus.data.data.totals / this.perPage);
                    this.totalData = restAccUserCus.data.data.totals;
                    this.loadingUser = false;
                })
                .catch(e => {
                    // this.error.push(e)
                });
        },
        searchAccountUserCustomerByUser: function () {
            this.page = 1;
            this.getAccountUserCustomer();
        },
        deleteAccountUserCustomer: function () {
            this.axios
                .delete(`${CONFIG.API_URL}/account-user-customer?id=` + this.txtSearch)
                .then(res => {
                    this.txtSearch = "";
                    this.getAccountUserCustomer();
                    helper.successMsg("Delete Successfull")
                }).catch(e => {
                    helper.errMsg("Delete Error")
                });

        },
        deleteAllAccountUserCustomerByCode: function () {
            this.axios
                .delete(`${CONFIG.API_URL}/account-user-customer/delete-by-code?code=` + this.txtCodeTodeleteAccountUser)
                .then(res => {
                    this.txtSearch = "";
                    this.getAccountUserCustomer();
                    helper.successMsg("Delete account user customer Successfull")
                }).catch(e => {
                    helper.errMsg("Delete Error")
                });

        },
        createAccountUserCustomer: function () {
          this.axios
            .post(`${CONFIG.API_URL}/account-user-customer`, this.userAccountCustomerForm)
            .then(res => {
              this.userAccountCustomerForm = {
                user: "",
                code: "",
                type: "",
              };
              jQuery('#addAccountUserCustomer').modal('hide');
              this.getAccountUserCustomer();
              if (res.data.success === true) {
                helper.successMsg("Add success")
              }
            })
            .catch(e => {
              helper.notifyError(e);
            });
        },
        updateAccountCustomer: function () {
            this.axios
                .put(`${CONFIG.API_URL}/role`, this.editRoleVO)
                .then(res => {
                    helper.successMsg("Update roles successful");
                });
        },
        getAccountCustomer: function () {
            this.loadingAccount = true;
            this.axios
                .get(`${CONFIG.API_URL}/account-customer/search?name=` + this.txtSearch + `&pageNo=` + this.pageAccountCus + `&pageSize=` + this.perPageAccountCus)
                .then(restAccCus => {
                    if (restAccCus.success == true) {

                    }
                    this.accCus = restAccCus.data.data.items;
                    console.log(restAccCus);
                    this.totalPagesAccountCus = Math.ceil(restAccCus.data.data.totals / this.perPageAccountCus);
                    this.totalDataAccountCus = restAccCus.data.data.totals;
                    this.loadingAccount = false;
                })
                .catch(e => {
                    // this.error.push(e)
                });
        },
        searchAccountCustomer: function () {
            this.pageAccountCus = 1;
            this.getAccountCustomer();
        },
        deleteAccountCustomer: function () {
            this.axios
                .delete(`${CONFIG.API_URL}/account-customer?id=` + this.txtSearch)
                .then(res => {
                    this.txtSearch = "";
                    this.deleteAllAccountUserCustomerByCode();
                    this.getAccountCustomer();
                    helper.successMsg("Delete Successfull")
                }).catch(e => {

                    helper.errMsg("Delete Error")
                });
        },
        createAccountCus: function () {
            let btnSaveUserRole = document.getElementById('btn-save-acc-customer');
            btnSaveUserRole.setAttribute('data-dismiss', '');
            this.accCusVO.deptCode = this.department.departmentCode;
            this.accCusVO.id = null;
            let divError = document.getElementsByClassName('error');
            this.hidenDivError();
            if (this.accCusVO.code == null || this.accCusVO.code == "") {
                divError[0].style.display = '-webkit-box';
            } else if (this.accCusVO.name == null || this.accCusVO.name == "") {
                divError[1].style.display = '-webkit-box';
            } else if (this.department == null || this.department == "" || !this.department instanceof Object) {
                divError[2].style.display = '-webkit-box';
            } else {
                btnSaveUserRole.setAttribute('data-dismiss', 'modal');

                this.axios
                    .post(`${CONFIG.API_URL}/account-customer`, this.accCusVO)
                    .then(res => {
                        this.accCusVO.code = "";
                        this.accCusVO.name = "";
                        this.department = "";

                        helper.successMsg(res.data.message[0].msg);
                        this.getAccountCustomer();

                    })
                    .catch(e => {
                        helper.errMsg(e.response.data.message[0].msg)

                    });
            }
        },

        updateAllAccountUserCusByCode: function (codeOld, codeNew) {
            this.axios.delete(`${CONFIG.API_URL}/account-user-customer/update-all-by-code?codeOld=` + codeOld + `&codeNew=` + codeNew)
                .then(res => {
                }).catch(e => {
                })
        },
        editAccountCus: function () {
            let divError = document.getElementsByClassName('error2');
            if (this.accCusVO.code == null || this.accCusVO.code == "") {
                divError[0].style.display = '-webkit-box';
            } else if (this.accCusVO.name == null || this.accCusVO.name == "") {
                divError[1].style.display = '-webkit-box';
            } else if (this.department == null || this.department == "" || !this.department instanceof Object) {
                divError[2].style.display = '-webkit-box';
            } else {
                this.accCusVO.deptCode = this.department.departmentCode;
                let btnSave = document.getElementById('btn-edit-acc-customer');
                btnSave.setAttribute('data-dismiss', 'modal');
                this.axios.put(`${CONFIG.API_URL}/account-customer`, this.accCusVO)
                    .then(res => {
                        this.txtSearch = "";
                        this.updateAllAccountUserCusByCode(this.codeOld, this.accCusVO.code)
                        this.getAccountCustomer();
                        helper.successMsg(res.data.message[0].msg);
                    }).catch(e => {
                        helper.errMsg(e.response.data.message[0].msg);
                    })
            }
        },
        searchAccountUserByCode: function (code) {
            this.isDisplaypagingSearchCode = true;
            this.isDisplaypagingAccount = false;
            this.getTextOnclick(code);
            this.tempCode = code;
            this.axios
                .get(`${CONFIG.API_URL}/account-user-customer/searchByCode?code=` + this.txtSearch + `&pageIndex=` + this.pageSearchByCode + `&pageSize=` + this.perPage)
                .then(restAccCus => {
                    this.txtSearch = "";
                    if (restAccCus.success == true) {

                    }
                    this.accUserCus = restAccCus.data.data.items;
                    this.totalPages = Math.ceil(restAccCus.data.data.totals / this.perPage);
                    this.totalData = restAccCus.data.data.totals;
                })
                .catch(e => {
                    // this.error.push(e)
                });
        },
        getDepartment: function () {
            this.axios
                .get(`${CONFIG.API_URL}/department/search?pageNo=1&pageSize=10`)
                .then(restDepts => {
                    this.depts = restDepts.data.data.items;
                })
                .catch(e => {
                    // this.error.push(e)
                });
        },
        getEmployee: function () {
            this.axios.get(
                `${CONFIG.API_URL}/employee/search?account=&notInRole=&pageNo=1&pageSize=10`
            ).then(resUser => {
                this.dataUser = resUser.data.data;
            }).catch(e => {
                this.error.push(e);
            })
        },
        fetchDepartment: async function (input) {
            if (input.length >= CONFIG.COMBOBOX_MIN_CHAR_TO_SEARCH || input.length === 0) {
                let searchProps = {
                    name: input
                };
                let data = await departmentCommon.sync.search(searchProps);
                this.depts = data.items;
            }
        },
        searchEmployee: async function (input) {
            let employeeResult = await employeeCommon.sync.search({
                account: input
            });
            this.dataUser = employeeResult;
        },
        getTextOnclick3: function(txt){
            this.userAccountCustomerForm.code = txt;
        },
        getTextOnclick: function (txt) {
            // codeAccountCustomer
            this.txtSearch = txt;
        },
        getTextOnclick2: function (txt, code) {
            this.txtSearch = txt;
            this.txtCodeTodeleteAccountUser = code;
        },
        clickEditAccountUser: function (code, name, deparmentCode, id) {
            this.hidenDivError();
            this.codeOld = code;
            this.accCusVO.code = code;
            this.accCusVO.name = name;
            this.accCusVO.deptCode = deparmentCode;
            this.accCusVO.id = id;
        },
        hidenDivError: function(){
            let divError = document.getElementsByClassName('error');
            divError.forEach(element => {
                element.style.display = 'none';
            });
            let divErrorEdit = document.getElementsByClassName('error2');
            divErrorEdit.forEach(element => {
                element.style.display = 'none';
            });
            let selectUserInModel = document.getElementsByClassName('error3');
            selectUserInModel.forEach(element => {
                element.style.display = 'none';
            });
        },
        clearText: function(){
            this.accCusVO.name = "";
            this.accCusVO.code  ="";
            this.department = "";
        }


    },

    watch: {
        page: {
            immediate: false,
            handler(newVal, oldVal) {
                this.getAccountUserCustomer();
            }
        },
        pageSearchByCode: {
            immediate: false,
            handler(newVal, oldVal) {
                this.searchAccountUserByCode(this.tempCode);
            }
        },
        pageAccountCus: {
            immediate: false,
            handler(newVal, oldVal) {
                this.getAccountCustomer();
            }
        }
    }
};
</script>

<style scoped>
@import '../../assets/css/table_customs.css';
@import '../../assets/css/dropdown_table_customs.css';

.header-table-roles .d-flex {
    align-items: center;
}

.header-table-roles .d-flex .button {
    display: flex;
    justify-content: flex-end;
}

.box-roles {
    height: auto;
}

#screen-roles-manager {
    margin-top: 20px;
}

.table-roles-user{
    padding: 20px 10px;
    background: #fff;
    width: 100%;
}

.table-roles-user .title {
  margin-top: 0;
  margin-left: -10px;
  margin-bottom: 20px;
  padding: 5px 0;
  border-left: 7px solid #3199bb;
  padding-left: 10px;
  font-weight: bold;
  color: grey;

}

.table-roles-user .title h6{
    font-weight: 600;
    font-size: 16px;
}

.table-roles-user table {
  width: 100%;
  table-layout: fixed;
}

td {
  font-weight: 500;
}

.table-roles-user table th {
  border-bottom: solid 1px #e3e9f0;
  border-top: none;
  font-size: 12px !important;
  vertical-align: top;
  color: #898e97;
  font-weight: 500;
}

.content {
    max-width: 1700px !important;
}


.modal-body form>.row {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: right;
}

.required:after {
    content: " * ";
    color: red;
}

.caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-top: 4px solid\9;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
}

div .errortemp {
    display: -webkit-box;
    color: red;
    margin-left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/AccountManager.vue